<template>
  <div class="course-body-container">
    <div class="row">
      <div class="col-lg-7 col-12 course-body-left">
        <h1 class="course-body-left-title">{{ data?.fields?.title }}</h1>
        <div v-for="(content, i) in data?.fields?.content?.content" :key="i">
          <div
            class="course-body-left-description"
            v-if="content.nodeType === 'paragraph'"
          >
            <span v-for="(content, x) in content.content" :key="x">
              <span
                v-if="content?.nodeType === 'hyperlink'"
                @click="openLink(content?.data?.uri)"
                class="hyper-link"
              >
                {{ content.content[0]?.value }}
              </span>
              <span v-else>{{ content?.value }}</span>
            </span>
          </div>
          <img
            v-if="content.nodeType === 'embedded-asset-block'"
            :src="imageUrl"
            class="course-body-left-image"
            alt="template body image"
          />
          <div
            v-if="content.nodeType === 'heading-4'"
            class="course-body-left-description-title"
          >
            {{ content.content[0]?.value }}
          </div>
          <div
            class="course-body-left-description"
            v-if="content.nodeType === 'unordered-list'"
          >
            <div
              class="course-body-left-bullets"
              v-for="(listItem, x) in content?.content"
              :key="x"
            >
              <i class="mdi mdi-check-circle our-solutions-check"></i>
              {{ listItem?.content[0]?.content[0]?.value }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-5 col-12">
        <div class="course-body-right-top">
          <div
            v-for="(content, i) in data?.fields?.description?.content"
            :key="i"
          >
            <div
              v-if="
                content?.nodeType.includes('heading') ||
                content?.nodeType === 'paragraph'
              "
              class="course-body-right-title"
            >
              {{ content?.content[0]?.value }}
            </div>
            <ul v-if="content.nodeType === 'unordered-list'">
              <li
                class="course-body-right-title-list"
                v-for="(listItem, i) in content?.content"
                :key="i"
              >
                {{ listItem?.content[0]?.content[0]?.value }}
              </li>
            </ul>
          </div>
        </div>
        <div class="course-body-right-bottom">
          <div class="course-body-right-bottom-title">
            {{ data?.fields?.cta?.content[0]?.content[0]?.value }}
          </div>
          <md-filled-tonal-button @click="$router.push('/book-demo')">
            {{
              data?.fields?.cta?.content[1]?.content.length > 0 &&
              data?.fields?.cta?.content[1]?.content[1]?.nodeType ===
                "hyperlink"
                ? data?.fields?.cta?.content[1]?.content[1]?.content[0]?.value
                : data?.fields?.cta?.content[1]?.content[0]?.value
            }}
            <i class="mdi mdi-arrow-right"></i>
          </md-filled-tonal-button>
        </div>
      </div>
    </div>
    <div class="course-body-left-description-title">
      {{ data?.fields?.structure?.content[0]?.content[0]?.value }}
    </div>
    <div>
      <v-expansion-panels v-model="panel" multiple>
        <v-expansion-panel
          v-for="(structure, x) in dataList(data?.fields?.structure?.content)"
          :key="x"
          class="course-body-expansion-panel"
        >
          <v-expansion-panel-title>
            <div class="course-body-expansion-title">
              <div>
                {{
                  structure?.subTitle?.content
                    ? structure?.subTitle?.content[0]?.value
                    : structure?.title?.content[0]?.value
                }}
              </div>
            </div>
          </v-expansion-panel-title>
          <v-expansion-panel-text class="course-body-expansion-body">
            <div class="course-body-expansion-body-title">
              {{ structure?.title?.content[0]?.value }}
              <ul
                class="course-body-expansion-body-list"
                v-for="(listItem, i) in structure?.list?.content"
                :key="i"
              >
                <li>
                  {{ listItem?.content[0]?.content[0]?.value }}
                </li>
              </ul>
            </div>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <div class="course-body-banner-bottom">
      <div class="course-body-banner-bottom-title">
        {{ data?.fields?.banner?.content[0]?.content[0]?.value }}
      </div>
      <md-filled-tonal-button
        @click="openLink(data?.fields?.cta?.content[1]?.content[1]?.data?.uri)"
      >
        {{
          data?.fields?.cta?.content[1]?.content.length > 0 &&
          data?.fields?.cta?.content[1]?.content[1]?.nodeType === "hyperlink"
            ? data?.fields?.cta?.content[1]?.content[1]?.content[0]?.value
            : data?.fields?.cta?.content[1]?.content[0]?.value
        }}
        <i class="mdi mdi-arrow-right"></i>
      </md-filled-tonal-button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "courseBody",
  props: ["data"],
  data() {
    return {
      panel: [0],
      imageUrl: "",
    };
  },
  mounted() {
    this.getImageURL(
      this.data?.fields?.content?.content[1]?.data?.target?.sys?.id
    );
  },
  methods: {
    getImageURL(assetId) {
      if (assetId) {
        axios
          .get(
            `https://cdn.contentful.com/spaces/8nqnktj51aoq/assets/${assetId}?access_token=njkIU16uuU7MPa5hOvzUO4deV6DFYht3xdwj6KUge-k`
          )
          .then((response) => {
            this.imageUrl = `https:${response.data.fields.file.url}`;
          });
      }
    },
    dataList(list) {
      const filteredList = [];
      list.forEach((item, x) => {
        if (
          item.nodeType === "heading-3" ||
          (item.nodeType === "paragraph" && x > 1 && x < list.length - 1)
        ) {
          filteredList.push({
            title: item,
            subTitle: list[x - 1]?.nodeType === "heading-2" ? list[x - 1] : {},
            list: list[x + 1]?.nodeType === "unordered-list" ? list[x + 1] : [],
          });
        }
      });
      return filteredList;
    },
    openLink(link) {
      window
        .open(
          `${
            link.includes("mail")
              ? ""
              : link.includes("https")
              ? ""
              : "https://"
          }${link}`,
          "_blank"
        )
        .focus();
    },
  },
};
</script>

<style></style>
